
interface Props {
  className?: string;
  reviewed: boolean | undefined;
}

export function EvidenceIcon({ className, reviewed = false }: Props) {
  return (
    <>
      {reviewed ? (
        <img
          src={require("../../../assets/icons/check.png")}
          className={className}
          alt="Tjek"
        />
      ) : (
        <img
          src={require("../../../assets/icons/minus.png")}
          className={className}
          alt="Negativ"
        />
      )}
    </>
  );
}
